/**
 * Активные статусы самолета (назначаются в `p.status`).
 * `rollout` и `deice` есть только в подписях — физика/таймеры без смены статуса.
 */
export type PlaneStatus =
  | "approach"
  | "inbound"
  | "landing"
  | "vacating"
  | "awaiting_gate"
  | "taxi_gate"
  | "service"
  | "ready"
  | "taxi_rwy"
  | "hold_short"
  | "takeoff"
  | "goaround";

/** Статусы, для которых есть подпись (включая неактивные) */
export type PlaneStatusLabel = PlaneStatus | "rollout" | "deice";

/** Полные подписи статусов для карточки / UI */
export const ST_LABEL: Record<PlaneStatusLabel, string> = {
  approach: "В зоне ожидания — нужна посадка",
  inbound: "Заходит на полосу",
  landing: "Садится",
  rollout: "Пробегает по полосе",
  vacating: "Съезжает с полосы",
  awaiting_gate: "Ждет свободный гейт — назначьте",
  taxi_gate: "Едет к гейту",
  service: "У гейта: посадка/высадка",
  ready: "Готов к вылету — отправьте на полосу",
  taxi_rwy: "Едет к полосе на взлет",
  hold_short: "У полосы — разрешите взлет",
  takeoff: "Взлетает",
  goaround: "Ушел на второй круг",
  deice: "На обработке",
};

/** Короткие подписи статусов для списков */
export const ST_SHORT: Record<PlaneStatusLabel, string> = {
  approach: "ждет посадки",
  inbound: "заход",
  landing: "посадка",
  rollout: "пробег",
  vacating: "съезд",
  awaiting_gate: "нужен гейт",
  taxi_gate: "к гейту",
  service: "у гейта",
  ready: "готов к вылету",
  taxi_rwy: "к полосе",
  hold_short: "ждет взлет",
  takeoff: "взлет",
  goaround: "второй круг",
  deice: "обработка",
};
